import React from 'react';
import { capitalize, find } from 'lodash';
import classnames from 'classnames';
import OTIcon from '../../tag/OTIcon';
import { formatCustom, formatTime } from '../../../utils/TimeUtils';

let { id: module_id } = module;

const TimesList = ({ times, selectTime, selectedTime }) => {
  return (
    <ol style={{ margin: 0 }}>
      {times.map((time) => {
        let isSelected =
          selectedTime && selectedTime.dateStart.isSame(time.dateStart);
        return (
          <li className={'timecell'} key={formatTime(time.dateStart)}>
            <div
              className={classnames('radio-block', { selected: !!isSelected })}
            >
              <input
                type="radio"
                id={`calendar-${formatCustom(time.dateStart, 'YYYYDDMM-HHmm')}`}
                checked={!!isSelected}
                onChange={() => selectTime(time)}
              />
              <span className={'radio-check'} />
              <label
                htmlFor={`calendar-${formatCustom(
                  time.dateStart,
                  'YYYYDDMM-HHmm'
                )}`}
                className={'radio-label'}
              >
                <div className={'timedisplay'}>
                  {formatTime(time.dateStart)} - {formatTime(time.dateEnd)}
                </div>
              </label>
            </div>
          </li>
        );
      })}
    </ol>
  );
};

export default TimesList;
